import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import { Authenticator } from '@aws-amplify/ui-react';
import { Box } from '@mui/material';
import Home from './pages/Home';
import Footer from './components/footer'; // Import the named export 'Footer' component
import Header from './components/header';
import Privacy from './pages/Privacy';
import HowToPlay from './pages/HowToPlay';
import Delete from './pages/Delete';
import DeleteConfirmation from './pages/DeleteConfirmation';
import Profile from './pages/Profile';
import Leaderboard from './pages/Leaderboard';
import Settings from './pages/Settings';
import Friends from './pages/Friends';
import FriendProfile from './pages/FriendProfile';
import AcceptInvite from './pages/AcceptInvite';
import { useAnalytics, setAnalyticsUserId } from './components/analytics';
import { useAuthGen2 } from './hooks/useAuthGen2';
import configureAmplifyGen2 from './configuration/amplify-gen2';
// import DebugPanel from './components/DebugPanel';

const AppContent: React.FC = () => {
  useAnalytics();
  const { user, isAuthenticated } = useAuthGen2();

  // Set Google Analytics user ID when authentication state changes
  useEffect(() => {
    if (isAuthenticated && user?.userId) {
      // Set the user ID for cross-session tracking
      setAnalyticsUserId(user.userId);
    } else {
      // Clear user ID on logout
      setAnalyticsUserId(null);
    }
  }, [isAuthenticated, user?.userId]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        width: '100%',
        maxWidth: '100vw',
        overflowX: 'hidden',
      }}
    >
      <Header />
      <Box component="main" sx={{ flexGrow: 1, width: '100%', maxWidth: '100vw', overflowX: 'hidden' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/howtoplay" element={<HowToPlay />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/friends" element={<Friends />} />
          <Route path="/friends/accept-invite" element={<AcceptInvite />} />
          <Route path="/friends/:friendId" element={<FriendProfile />} />
          <Route path="/delete" element={<Delete />} />
          <Route path="/delete/confirmation/:id" element={<DeleteConfirmation />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Box>
      <Footer />
    </Box>
  );
};

const App: React.FC = () => {
  // Configure Amplify on app startup
  useEffect(() => {
    try {
      configureAmplifyGen2();
    } catch (error) {
      console.error('Failed to configure Amplify:', error);
      // Don't throw - allow app to continue even if Amplify fails
      // User will be able to play without authentication
    }
  }, []);

  return (
    <Authenticator.Provider>
      <AppContent />
      {/* <DebugPanel /> */}
    </Authenticator.Provider>
  );
};

export default App;
